package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.autoResponsiveness

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.CountriesEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.AppConstantsEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.toTwoDecimalString
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.jetbrains.compose.web.css.px


@Composable
fun Price(
    price: List<Double?>?,
    windowSizeMode: WindowSizeModeEnum,
    countryId: String,
    selectedVat: String?,
    priceLevels: List<String?>?,
    updatePrice: (List<Double?>) -> Unit,
    updateVatCode: (String) -> Unit,
){
    Row(
        modifier = Modifier
            .autoResponsiveness()
        , verticalAlignment = Alignment.Bottom,
    )
    {
        val price1 = price?.getOrNull(0)
        val price2 = price?.getOrNull(1)
        val price3 = price?.getOrNull(2)


        CustomEditText(
            modifier = Modifier,
            marginBottom =Dimen.highLargePadding,
            marginRight = if (windowSizeMode==WindowSizeModeEnum.PHONE) 0.px
                else Dimen.largePadding,
            width = Dimen.normalEditTextWidth2,
            height = Dimen.mediumOutlinedEditTextHeight,
            label =priceLevels?.getOrNull(0) ?: (Strings.current().price + " " + 0),
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            isOutlinedEditText = true,
            textAlign = TextAlign.End,
            value = price1.toTwoDecimalString(useDotDigitStatus(countryId)),
            isDecimal = true,
            isRequired = false,
            usingDotForDigit = useDotDigitStatus(countryId),
            onFocusIn = {},
            onFocusOut = { inputValue ->
                val prices = arrayListOf<Double?>()
                prices.add(safeStringToDouble(inputValue))
                prices.add(price2)
                prices.add(price3)
                updatePrice(prices)
            },
            onInputChange = {it, validation -> }
        )

        CustomEditText(
            modifier = Modifier ,
            marginBottom =Dimen.highLargePadding,
            marginRight = if (windowSizeMode==WindowSizeModeEnum.PHONE) 0.px
                else Dimen.largePadding,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            width = Dimen.normalEditTextWidth2,
            height = Dimen.mediumOutlinedEditTextHeight,
            label =priceLevels?.getOrNull(1)?:Strings.current().price1,
            isOutlinedEditText = true,
            textAlign = TextAlign.End,
            value = price2.toTwoDecimalString(useDotDigitStatus(countryId)),
            isDecimal = true,
            isRequired = false,
            usingDotForDigit = useDotDigitStatus(countryId),
            onFocusIn = {},
            onFocusOut = { inputValue ->
                val prices = arrayListOf<Double?>()
                prices.add(price1)
                prices.add(safeStringToDouble(inputValue))
                prices.add(price3)
                updatePrice(prices)
            },
            onInputChange = {it, validation -> }
        )

        CustomEditText(
            modifier = Modifier ,
            marginBottom =Dimen.highLargePadding,
            marginRight = if (windowSizeMode==WindowSizeModeEnum.PHONE) 0.px
                else Dimen.largePadding,
            width = Dimen.normalEditTextWidth2,
            height = Dimen.mediumOutlinedEditTextHeight,
            label =priceLevels?.getOrNull(2)?:Strings.current().price2,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            isOutlinedEditText = true,
            textAlign = TextAlign.End,
            value = price3.toTwoDecimalString(useDotDigitStatus(countryId)),
            isDecimal = true,
            isRequired = false,
            usingDotForDigit = useDotDigitStatus(countryId),
            onFocusIn = {},
            onFocusOut = { inputValue ->
                val prices = arrayListOf<Double?>()
                prices.add(price1)
                prices.add(price2)
                prices.add(safeStringToDouble(inputValue))
                updatePrice(prices)
            },
            onInputChange = {it, validation -> }
        )

        DropDownItem(
            modifier = Modifier
                .margin(
                    bottom = Dimen.highLargePadding,
                ),
            options = AppConstantsEnum.entries,
            label = Strings.current().vat,
            itemWidth = Dimen.normalEditTextWidth2,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            selectedItem = AppConstantsEnum.entries.find {
                it.value == selectedVat
            },
            displayText = {
                if (it is AppConstantsEnum)
                    it.label else ""
            },
            onOptionClick = {
                if (it is AppConstantsEnum)
                    updateVatCode(it.value)
            }
        )

    }
}



fun safeStringToDouble(value: String): Double? {
    if (value.isEmpty()) return null

    val floatStr = value.replace(',', '.')
    val num = js("parseFloat")(floatStr)
    return if (js("isNaN")(num) as Boolean) null else num as Double
}


fun useDotDigitStatus(countryId: String): Boolean {
    return countryId != CountriesEnum.GERMANY.id
}



